import { render, staticRenderFns } from "./KanbanTuner.vue?vue&type=template&id=32026a9d&scoped=true&"
import script from "./KanbanTuner.vue?vue&type=script&lang=js&"
export * from "./KanbanTuner.vue?vue&type=script&lang=js&"
import style0 from "./KanbanTuner.vue?vue&type=style&index=0&id=32026a9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32026a9d",
  null
  
)

export default component.exports